var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag state",class:[_vm.state, _vm.size]},[_vm._v(_vm._s(!_vm.singular ? _vm.$t(("reports.state." + _vm.state)) : _vm.$t(("reports.state." + _vm.state + ".singular"))))])}
var staticRenderFns = []

export { render, staticRenderFns }